import React, { useState, useContext, useEffect } from 'react'
import { EventListContext } from '../../../utils/context'
import styles from './styles.module.scss'
import Table from '../../../components/Table'
import Confirmation from '../../../components/Confirmation/Confirmation'
import { BiTrash } from 'react-icons/bi'
import PeopleModal from './Components/PeopleModal'
import ModalFooter from './Components/ModalFooter'
import { Input } from '../../../components/ModalInputs'


export default function Responsible() {

  const { event, closeModal, formik } = useContext(EventListContext)

  const { values, setFieldValue, handleSubmit } = formik
  const teachers = values.teachers || []

  const [confirmation, setConfirmation] = useState(false);

  // Синхронизация с существующими данными при редактировании
  useEffect(() => {
    if (event?.responsibles && event.responsibles.length > 0 && teachers.length === 0) {
      setFieldValue('teachers', event.responsibles.map(r => ({
        mid: r.mid,
        comment: r.comment || '',
        fio: r.fio,
        calc_posts: r.calc_posts || r.post || '',
        xp_key: r.xp_key
      })))
    }
  }, [event?.responsibles])

  const acceptConfirmation = () => {
    const updatedTeachers = teachers.filter(t => t.xp_key !== confirmation.id && t.mid !== confirmation.id)
    setFieldValue('teachers', updatedTeachers)
    setConfirmation(false);
  };

  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const onAddResponsible = (person) => {
    const newTeacher = {
      mid: person.mid,
      comment: '',
      fio: person.calc_fio || person.fio,
      calc_posts: person.calc_posts || ''
    }
    setFieldValue('teachers', [...teachers, newTeacher])
  }

  const handleCommentChange = (mid, value) => {
    const teacherIndex = teachers.findIndex(t => t.mid === mid)
    if (teacherIndex !== -1) {
      setFieldValue(`teachers[${teacherIndex}].comment`, value)
    }
  }

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          {confirmation && (
            <Confirmation
              top="30px"
              left="40px"
              title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
              acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
              rejectConfirmation={rejectConfirmation}
            />
          )}
          <Table>
            <thead>
              <tr>
                <th>ФИО</th>
                <th>Должность</th>
                <th>Комментарий</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {teachers.map((teacher) =>
                <tr key={teacher.xp_key || teacher.mid}>
                  <td>{teacher.fio}</td>
                  <td>{teacher.calc_posts || ''}</td>
                  <td>
                    <Input
                      value={teacher.comment || ''}
                      onChange={(e) => handleCommentChange(teacher.mid, e.target.value)}
                      style={{ width: '150px' }}
                    />
                  </td>
                  <td>
                    <i
                      className={styles.trash}
                      onClick={() => setConfirmation({ id: teacher.xp_key || teacher.mid, name: teacher.fio })}
                    >
                      <BiTrash />
                    </i>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <PeopleModal onSubmit={onAddResponsible} />
        </div>
      </div>
      <ModalFooter
        event={event}
        onSave={handleSubmit}
        onClose={closeModal}
        showCheckbox={false}
      />
    </>
  )
}
